module.exports = __webpack_public_path__ + "img/3.5255b6f8.jpg";